import moment from "moment";

export const smallerDateYear = (y1: string, y2: string) => {
  const year1 = moment.utc(y1);
  const year2 = moment.utc(y2);
  const res = year1.isBefore(year2) ? year1.year() : year2.year();
  return res.toString();
};

export const updatedResDate = (existYear?: string | null, newYear?: string | null) => {
  const ex = existYear?.trim();
  const n = newYear?.trim();
  if (ex && n) {
    return smallerDateYear(ex, n);
  } else if (!ex && n) {
    return n;
  } else if (ex && !n) {
    return ex;
  } else {
    return null;
  }
};

export const getIVOUpdateBody = (name: string, ssn: string, ivoGrundSetOn: Date) => {
  const _ivoGrundSetOn = ivoGrundSetOn
    ? moment(ivoGrundSetOn).format("YYYY-MM-DD")
    : null;
  return `
      Hej,

      Kan ni vänligen kontrollera nedanstående persons ärendehistorik (pågående/avslutade ärenden)?

      ${name}
      ${ssn}
      Senaste kontroll: ${_ivoGrundSetOn ?? "-"}

      Vi vill att ni söker på både namn och personnummer för att säkerställa att all information/historik följer med. Vi vill att ni söker från 1e jan det år då senaste kontroll gjordes.

      Tack på förhand!
    `;
};
